/*
 *   File : aprrove-kyc.js
 *   Author URI : https://evoqins.com
 *   Description : UI element which asks for viewing docs.
 *   Integrations : null
 *   Version : v1.1
 */
/* import packages */
import { Fragment, useEffect } from "react";

/* import components */
import { Icon } from "../Icon";

/* import styles */
import style from "../../Styles/Components/delete.module.scss";

/* import helper */

const ViewDocModal = (props) => {

    useEffect(() => {
        var my_modal = document.getElementById("view-doc");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
        //eslint-disable-next-line
    }, [props.close]);


    return (
        <div className={`modal fade ${style.e_approve_kyc}`}
            id="view-doc"
            tabIndex="-1"
            aria-labelledby="view-doc"
            aria-hidden="true"
            data-bs-backdrop="true" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-white  padding-32px-all ${style.e_content} `}>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <p className="e-poppins-medium e-font-18 line-height-16px mb-0">View Docs</p>
                        <Icon icon="close"
                            size={24}
                            data-bs-dismiss="modal"
                            className="cursor-pointer e-modal-close-btn" />
                    </div>


                    {
                        props.type === 1 ?
                            <Fragment>
                                <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">HUF PAN Proof</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.huf_pan_url)}>Download</p>
                                </div>

                                {props.data.bank_statement_url && <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Bank Statement</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.bank_statement_url)}>Download</p>
                                </div>}

                                {props.data.bank_cheque_url && <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Bank Cheque</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.bank_cheque_url)}>Download</p>
                                </div>}
                                <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Karta PAN Proof</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.karta_pan_url)}>Download</p>
                                </div>
                                <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Karta Address Proof</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.karta_proof_url)}>Download</p>
                                </div>
                                {props.data.karta_kyc_form_url && <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">KYC form of karta</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.karta_kyc_form_url)}>Download</p>
                                </div>}
                                {props.data.bse_form_url && <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Account Opening Form (BSE/AOF)</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.bse_form_url)}>Download</p>
                                </div>}
                                {/* {props.data.bse_form_url && <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Non-individual KYC (BSE AOF)</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.bse_form_url)}>Download</p>
                                </div>} */}
                                {props.data.ubo_form_url && <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">FATCA/UBO</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.ubo_form_url)}>Download</p>
                                </div>}
                                {/* {props.data.coparcener_kyc_form_url && <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">KYC form of coparcener</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.coparcener_kyc_form_url)}>Download</p>
                                </div>} */}

                                {props.data.non_ind_coparcener_form_url && <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Non-individual coparcener list</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.non_ind_coparcener_form_url)}>Download</p>
                                </div>}
                            </Fragment>
                            :
                            <Fragment>
                                {props.data.minor_pan_proof && <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Minor PAN Proof</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.minor_pan_proof)}>Download</p>
                                </div>}
                                <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Minor DOB Proof</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.minor_dob_proof)}>Download</p>
                                </div>
                                <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Bank Cheque</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.bank_cheque_url)}>Download</p>
                                </div>
                                <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Guardian PAN Proof</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.guardian_pan_proof)}>Download</p>
                                </div>
                                <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Guardian Address Proof</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.guardian_address_proof)}>Download</p>
                                </div>
                                <div className="d-flex gap-3 align-items-center pt-4 mb-2">
                                    <p className="color-outer-space e-poppins-regular e-font-18 line-height-18px mb-0">Guardian Signature</p>
                                    <p className="color-primary-color e-poppins-medium e-font-16 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                                        onClick={() => window.open(props.data.guardian_signature)}>Download</p>
                                </div>

                            </Fragment>
                    }
                </div>
            </div>
        </div>
    )
}


ViewDocModal.defaultProps = {
    close: () => { }
}

export default ViewDocModal